import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../css/SubcategoryPage.css";
import axios from "axios";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import CategoryIcon from "@mui/icons-material/Category";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const SubcategoryPage = () => {
    const [subCategories, setSubCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { category } = useParams();
    const apiUrl = `${process.env.REACT_APP_API}`;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    useEffect(() => {
        const fetchSubcategories = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(`${apiUrl}/categories/${category}/subcategories`);
                setSubCategories(response.data.subCategories);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching subcategories:", error);
                setIsLoading(false);
            }
        };

        fetchSubcategories();
    }, [category]);

    const formatCategoryName = (slug) => {
        return slug
            .split("-")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    return (
        <>
            <Header />
            <div className="subcategory-page">
                <div className="container py-5">
                    {/* Page Header */}
                    <div className="subcategory-header text-center mb-5">
                        <CategoryIcon style={{ fontSize: "3rem", color: "#002e6a", marginBottom: "1rem" }} />
                        <h1 className="subcategory-page-title">
                            {formatCategoryName(category)}
                        </h1>
                        <p className="subcategory-page-subtitle">Choose your style</p>
                        <div className="title-underline"></div>
                    </div>

                    {/* Loading State */}
                    {isLoading && (
                        <div className="text-center my-5">
                            <div className="spinner-border" style={{ color: "#c70044" }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2 text-muted">Loading categories...</p>
                        </div>
                    )}

                    {/* Subcategories Grid */}
                    {!isLoading && subCategories.length > 0 && (
                        <div className="subcategories-grid">
                            {subCategories.map((subCategory, index) => (
                                <Link
                                    key={index}
                                    to={`/${category}/products/${subCategory.slug}`}
                                    className="subcategory-card-link"
                                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                                >
                                    <div className="subcategory-card">
                                        <div className="subcategory-image-wrapper">
                                            <img
                                                src={subCategory.image}
                                                alt={subCategory.name}
                                                className="subcategory-image"
                                                loading="lazy"
                                            />
                                            <div className="subcategory-overlay">
                                                <ArrowForwardIcon className="arrow-icon" />
                                            </div>
                                        </div>
                                        <div className="subcategory-info">
                                            <h3 className="subcategory-name">{subCategory.name}</h3>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {!isLoading && subCategories.length === 0 && (
                        <div className="text-center my-5">
                            <div className="empty-state-card">
                                <CategoryIcon style={{ fontSize: "5rem", color: "#ccc", margin: "0 auto 1rem" }} />
                                <h4>No Categories Available</h4>
                                <p className="text-muted mb-4">
                                    There are currently no subcategories in this section.
                                </p>
                                <Link to="/" className="btn empty-state-button">
                                    Back to Home
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default SubcategoryPage;